// extracted by mini-css-extract-plugin
export default {"Header":"AIProjectHeader_Header__-CqkC","Header_Step":"AIProjectHeader_Header_Step__MXC0E","Header_Step_Completed":"AIProjectHeader_Header_Step_Completed__fmZ31"};